import { Action, combineReducers } from "redux";
import { IMessagePage } from "source/models/message/messagePage";

// State
export interface IMessagePageState {
    dataId: number;
    messagePage: IMessagePage;
}

export interface IMessageState {
    page: IMessagePageState;
}

// Action type constants
const MESSAGE_SUCCESS = "MESSAGE_SUCCESS";
const MESSAGE_FAILURE = "MESSAGE_FAILURE";

type T_MESSAGE_SUCCESS = typeof MESSAGE_SUCCESS;
type T_MESSAGE_FAILURE = typeof MESSAGE_FAILURE;

// Action types
interface IMessageSuccess extends Action {
    type: T_MESSAGE_SUCCESS;
    messagePage: IMessagePage;
}

interface IMessageFailure extends Action {
    type: T_MESSAGE_FAILURE;
}

export type MessageAction =
    | IMessageSuccess
    | IMessageFailure;

//Actions
export const messageSuccess = (messagePage: IMessagePage): IMessageSuccess => ({
    type: MESSAGE_SUCCESS,
    messagePage
});

export const messageFailure = (): IMessageFailure => ({
    type: MESSAGE_FAILURE
});

//Reducers
export const messageInitialState: IMessageState = {
    page: {
        dataId: 0,
        messagePage: null
    }
};

const page = (state: IMessagePageState = null, action: MessageAction) => {
    switch (action.type) {
    case MESSAGE_SUCCESS: {
        const messageSuccess = action as IMessageSuccess;
        return {
            ...state,
            dataId: state.dataId + 1,
            messagePage: messageSuccess.messagePage
        };
    }
    case MESSAGE_FAILURE:
        return { ...state };
    }
    return state;
};

//Root reducer
export const messageReducer = combineReducers({
    page
});

//Utils